function sliderVtext() {
  // Ensure fade CSS exists for this block namespace
  if (!document.getElementById('vtext-fade-style')) {
    const style = document.createElement('style');
    style.id = 'vtext-fade-style';
    style.textContent = `
      /* Force overlap (stack) for main slider in fade mode */
      .slider-wrapper-vtext .splide:not(.splide--text-nav) .splide__slide { position: absolute; top: 0; left: 0; width: 100%; }
      /* Make text nav track scrollable; hide native scrollbars to use a custom one */
      .slider-wrapper-vtext .splide--text-nav { position: relative; }
      .slider-wrapper-vtext .splide--text-nav .splide__track::-webkit-scrollbar { width: 0; height: 0; }
      /* Natural stacking for nav items; avoid fixed heights */
      .slider-wrapper-vtext .splide--text-nav .splide__slide { height: auto !important; }
      /* Provide left space so the custom thumb does not overlap labels (desktop only) */
      /* Custom left-side scrollbar (fake) */
      .slider-wrapper-vtext .vtext-scrollbar { position: absolute; left: 0; top: 0; bottom: 0; width: 12px; pointer-events: none; background: #DFDFDF; border-radius: 9999px; }
      .slider-wrapper-vtext .vtext-scrollbar.is-dragging { pointer-events: auto;}
      .slider-wrapper-vtext .vtext-scrollbar__thumb { position: absolute; left: 0; width: 12px; height: 36px; background: #232323; border-radius: 9999px; transition: top 500ms ease-in-out; }
    `;
    document.head.appendChild(style);
  }
  [...document.querySelectorAll('.slider-wrapper-vtext .splide')]?.forEach(slider => {
    // Per-instance guards and state
    let hasBoundWindowListeners = false;
    let resizeTimeout = null;
    let isReinitializing = false;
    let splideInstance;
    let navInstance;
    const wrapper = slider.closest('.slider-wrapper-vtext');
    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;

    // Known vertical paddings for .splide__slide in this block (keep REM units here)
    // See assets/css/blocks/group--slider-wrapper-vtext.css
    const paddingTopMobileRem = '2.25rem';   // pt-9
    const paddingBottomMobileRem = '1.25rem'; // pb-5
    const paddingTopDesktopRem = '2.25rem';  // lg:py-9
    const paddingBottomDesktopRem = '2.25rem'; // lg:py-9

    // Helper: convert rem string to px number based on current root font-size
    const remToPx = (remStr) => {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      const remVal = parseFloat(remStr);
      return Math.round(remVal * rootFontSize);
    };

    // Apply inline paddings to slides before measuring, using rem values (ensures consistency)
    const applySlidePaddings = () => {
      const isDesktop = window.innerWidth >= 1024;
      const pt = isDesktop ? paddingTopDesktopRem : paddingTopMobileRem;
      const pb = isDesktop ? paddingBottomDesktopRem : paddingBottomMobileRem;
      const slides = slider.querySelectorAll('.splide__slide');
      slides.forEach(li => {
        li.style.paddingTop = pt;
        li.style.paddingBottom = pb;
      });
    };

    // Helper: compute tallest slide height including vertical margins and paddings
    const getTallestSlideHeight = () => {
      const isDesktop = window.innerWidth >= 1024;
      const verticalPadding = (isDesktop
        ? (remToPx(paddingTopDesktopRem) + remToPx(paddingBottomDesktopRem))
        : (remToPx(paddingTopMobileRem) + remToPx(paddingBottomMobileRem)));

      const slides = slider.querySelectorAll('.splide__slide');
      let max = 0;

      slides.forEach(li => {
        const style = window.getComputedStyle(li);
        const marginTop = parseFloat(style.marginTop) || 0;
        const marginBottom = parseFloat(style.marginBottom) || 0;

        // Prepare to measure even if the slide is hidden (e.g., display:none by Splide)
        const prev = {
          display: li.style.display,
          position: li.style.position,
          visibility: li.style.visibility,
          opacity: li.style.opacity,
          left: li.style.left,
          right: li.style.right,
          top: li.style.top,
        };

        let needTempExpose = (style.display === 'none' || li.offsetHeight === 0);
        if (needTempExpose) {
          li.style.display = 'block';
          li.style.position = 'absolute';
          li.style.visibility = 'hidden';
          li.style.opacity = '0';
          li.style.left = '-99999px';
          li.style.top = '0';
        }

        // Try to measure inner content height without the slide's own paddings
        const inner = li.querySelector('.slider__item') || li.firstElementChild || li;
        const innerRectH = inner.getBoundingClientRect().height;
        const innerH = Math.max(inner.scrollHeight, inner.offsetHeight, innerRectH);

        // Restore previous inline styles if we temporarily exposed the slide
        if (needTempExpose) {
          li.style.display = prev.display || '';
          li.style.position = prev.position || '';
          li.style.visibility = prev.visibility || '';
          li.style.opacity = prev.opacity || '';
          li.style.left = prev.left || '';
          li.style.right = prev.right || '';
          li.style.top = prev.top || '';
        }

        // Total height = inner content + known vertical padding + margins
        const h = innerH + verticalPadding + marginTop + marginBottom;
        if (h > max) max = h;
      });
      return Math.ceil(max);
    };

    const buildNav = () => {
      const existing = wrapper.querySelector('.splide--text-nav');
      if (existing) {
        existing.parentNode.removeChild(existing);
      }
      const nav = document.createElement('div');
      nav.className = 'splide splide--text-nav';
      const track = document.createElement('div');
      track.className = 'splide__track';
      const ul = document.createElement('ul');
      ul.className = 'splide__list';
      const slides = slider.querySelectorAll('.splide__slide');
      slides.forEach((li, i) => {
        const navText = li.getAttribute('data-nav-label')
          || (li.querySelector('h1, h2, h3, h4, h5, h6')?.textContent || '').trim()
          || `Slide ${i + 1}`;
        const item = document.createElement('li');
        item.className = 'splide__slide';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'splide__slide__label';
        btn.textContent = navText;
        item.appendChild(btn);
        ul.appendChild(item);
      });
      track.appendChild(ul);
      nav.appendChild(track);
      // Inject custom arrows for navOptions (prev/next)
      const arrows = document.createElement('div');
      arrows.className = 'splide__arrows';
      arrows.innerHTML = `
        <button class="splide__arrow splide__arrow--prev" type="button" aria-label="Previous">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.05713 7.99023L15 7.99023" stroke="#232323" stroke-width="1.6" stroke-miterlimit="1" stroke-linecap="round"/>
            <path d="M0.885742 7.99033L7.95913 15" stroke="#232323" stroke-width="1.6" stroke-miterlimit="1" stroke-linecap="round"/>
            <path d="M0.885742 7.99023L7.95913 0.999905" stroke="#232323" stroke-width="1.6" stroke-miterlimit="1" stroke-linecap="round"/>
          </svg>
        </button>
        <button class="splide__arrow splide__arrow--next" type="button" aria-label="Next">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.9429 8.00977L0.999993 8.00977" stroke="#232323" stroke-width="1.6" stroke-miterlimit="1" stroke-linecap="round"/>
            <path d="M15.1143 8.00967L8.04087 1" stroke="#232323" stroke-width="1.6" stroke-miterlimit="1" stroke-linecap="round"/>
            <path d="M15.1143 8.00977L8.04087 15.0001" stroke="#232323" stroke-width="1.6" stroke-miterlimit="1" stroke-linecap="round"/>
          </svg>
        </button>`;
      nav.appendChild(arrows);
      const container = wrapper.querySelector('.alignwide');
      if (container) {
        container.insertBefore(nav, container.firstChild);
      } else {
        wrapper.insertBefore(nav, wrapper.firstChild);
      }
      return nav;
    };

    const initSlider = () => {
      if (isReinitializing) return;
      isReinitializing = true;
      const windowWidth = window.innerWidth;
      const type = 'fade';
      const mainGap = 0;

      if (splideInstance) {
        splideInstance.destroy();
        splideInstance = null;
      }
      if (navInstance) {
        navInstance.destroy();
        navInstance = null;
      }

      // Always vertical text nav for this block
      const navRoot = buildNav();

      // Reset any previously set inline heights before measuring to avoid cumulative rounding drift
      slider.style.height = '';
      // Ensure paddings are applied before measuring
      applySlidePaddings();
      // Compute tallest slide height and use it for main slider height
      const tallestHeight = getTallestSlideHeight();
      if (tallestHeight > 0) {
        // Set inline height on root to avoid layout jumps before mount
        slider.style.height = tallestHeight + 'px';
      }

      // Constrain nav container to enable scrollbar visibility
      if (navRoot) {
        // On desktop (vertical nav), match nav height to main slider so it can scroll internally
        if (window.innerWidth >= 1024 && tallestHeight > 0) {
          navRoot.style.height = tallestHeight + 'px';
        } else {
          navRoot.style.height = '';
        }
        const trackEl = navRoot.querySelector('.splide__track');
        if (trackEl) {
          // Ensure the track fills the container and can overflow within it
          if (window.innerWidth >= 1024) {
            trackEl.style.height = '100%';
          } else {
            trackEl.style.height = '';
          }
          // Use native scrolling but hide its UI (we'll render a custom thumb)
          trackEl.style.overflow = 'auto';

          // Prepare custom scrollbar only on desktop (vertical nav)
          if (window.innerWidth >= 1024) {
            navRoot.style.position = navRoot.style.position || 'relative';
            const existingBar = navRoot.querySelector('.vtext-scrollbar');
            if (existingBar) existingBar.remove();
            const bar = document.createElement('div');
            bar.className = 'vtext-scrollbar';
            const thumb = document.createElement('div');
            thumb.className = 'vtext-scrollbar__thumb';
            bar.appendChild(thumb);
            // Place the custom scrollbar inside the text nav, after the list, per requirement
            if (trackEl) {
              trackEl.appendChild(bar);
            } else {
              navRoot.appendChild(bar);
            }

            const positionThumbToActive = () => {
              const active = navRoot.querySelector('.splide__slide.is-active');
              if (!active) return;
              const navRect = navRoot.getBoundingClientRect();
              const activeRect = active.getBoundingClientRect();
              const thumbH = 36; // must match CSS
              let top = Math.round(activeRect.top - navRect.top + (activeRect.height - thumbH) / 2);
              // clamp within container
              top = Math.max(0, Math.min(navRoot.clientHeight - thumbH, top));
              thumb.style.top = top + 'px';
            };

            // Update when nav changes active slide or when user scrolls/resizes
            trackEl.addEventListener('scroll', positionThumbToActive, { passive: true });
            // Hook splide nav events after instances mount (listeners added later)
            setTimeout(positionThumbToActive, 0);
            window.addEventListener('resize', positionThumbToActive);

            // Expose helper to outer scope via DOM for later binding after mount
            navRoot._positionThumbToActive = positionThumbToActive;
          }
        }
      }

      const mainOptions = {
        direction: 'ttb',
        height: 'auto',
        type: type,
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage: 1,
        perMove: 1,
        gap: mainGap,
        lazyload: 'sequential',
        rewind: true,
        mediaQuery: 'min',
        pagination: false,
        arrows: false,
        autoplay: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 7000,
        focusableNodes: true,
      };
      const navOptions = {
        direction: window.innerWidth < 1024 ? 'ltr' : 'ttb',
        isNavigation: true,
        pagination: false,
        arrows: window.innerWidth < 1024,
        drag: 'free',
        snap: true,
        rewind: window.innerWidth < 1024,
        type: window.innerWidth < 1024 ? 'fade' : 'slide',
        perPage: window.innerWidth < 1024 ? 1 : (Math.min(6, slider.querySelectorAll('.splide__slide').length) || 4),
        height: '100%',
        gap: '',
      };
      splideInstance = new Splide(slider, mainOptions);
      navInstance = new Splide(navRoot, navOptions);
      splideInstance.sync(navInstance);

      // Keep custom thumb aligned with the current active item in nav
      const alignThumb = () => { if (navRoot && navRoot._positionThumbToActive) navRoot._positionThumbToActive(); };
      navInstance.on('mounted', alignThumb);
      navInstance.on('active', alignThumb);
      navInstance.on('moved', alignThumb);
      splideInstance.on('active', alignThumb);
      splideInstance.on('moved', alignThumb);

      if (type === 'fade') {
        // Ensure no horizontal offset in fade mode
        slider.querySelectorAll('.splide__slide').forEach(li => {
          li.style.margin = '0';
        });
        const listEl = slider.querySelector('.splide__list');
        if (listEl) {
          listEl.style.gap = '0';
        }
        // Neutralize any translateX applied by defaults in fade mode
        splideInstance.on('mounted moved', () => {
          slider.querySelectorAll('.splide__slide').forEach(li => {
            li.style.transform = 'translateX(0)';
          });
        });
      } else {
        // Fallback fade-like effect for non-fade types (currently not used)
        splideInstance.on('move', function (newIndex, prevIndex, destIndex) {
          const slides = slider.querySelectorAll('.splide__slide');
          slides.forEach(function(el, index) {
            if (index < destIndex) {
              el.classList.add('fade-out');
            } else {
              el.classList.remove('fade-out');
            }
          });
        });
      }


      // Mount and attach events
      splideInstance.mount();
      navInstance.mount();

      // After mount: defer and event-driven recalculation to catch late-rendered content (e.g., images, fonts)
      const recalcAndApplyHeights = () => {
        // Reset heights to let content flow naturally before re-measuring
        slider.style.height = '';
        if (navRoot) {
          navRoot.style.height = '';
          const trackEl2 = navRoot.querySelector('.splide__track');
          if (trackEl2) trackEl2.style.height = '';
        }
        // Ensure paddings are applied before re-measuring
        applySlidePaddings();
        const tallestHeight2 = getTallestSlideHeight();
        if (tallestHeight2 > 0) {
          slider.style.height = tallestHeight2 + 'px';
          if (navRoot) {
            if (window.innerWidth >= 1024) {
              navRoot.style.height = tallestHeight2 + 'px';
              const trackEl2 = navRoot.querySelector('.splide__track');
              if (trackEl2) trackEl2.style.height = '100%';
            } else {
              navRoot.style.height = '';
              const trackEl2 = navRoot.querySelector('.splide__track');
              if (trackEl2) trackEl2.style.height = '';
            }
          }
          // Align custom thumb after any layout change
          if (navRoot && navRoot._positionThumbToActive) {
            try { navRoot._positionThumbToActive(); } catch (e) {}
          }
        }
      };

      // Schedule immediate and slightly delayed recalculations
      setTimeout(recalcAndApplyHeights, 0);
      setTimeout(recalcAndApplyHeights, 300);
      setTimeout(recalcAndApplyHeights, 900);

      // Recalculate when active slide changes (ensures hidden tallest slides are considered when they become visible)
      if (splideInstance) {
        splideInstance.on('active', recalcAndApplyHeights);
        splideInstance.on('updated', recalcAndApplyHeights);
        splideInstance.on('resized', recalcAndApplyHeights);
      }
      if (navInstance) {
        navInstance.on('active', recalcAndApplyHeights);
      }

      // Recalculate when images inside the slider finish loading
      const imgs = slider.querySelectorAll('img');
      imgs.forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', recalcAndApplyHeights, { once: true });
          img.addEventListener('error', recalcAndApplyHeights, { once: true });
        }
      });

      // Recalculate after fonts are ready (if supported)
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => recalcAndApplyHeights()).catch(() => {});
      }
      // Release reinitialization guard
      isReinitializing = false;
    };

    initSlider();
    if (!hasBoundWindowListeners) {
      window.addEventListener('resize', () => {
        if (resizeTimeout) clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => { initSlider(); }, 150);
      }, { passive: true });
      window.addEventListener('load', () => { initSlider(); }, { once: true });
      hasBoundWindowListeners = true;
    }
  });
}

// Attach a global capture click handler to reset heights before Splide reacts to nav clicks
if (!window.__vtextPreClickResetBound) {
  window.__vtextPreClickResetBound = true;
  document.addEventListener('click', function(e){
    var label = e.target && e.target.closest && e.target.closest('.slider-wrapper-vtext .splide--text-nav .splide__slide__label');
    if(!label) return;
    var wrapper = label.closest('.slider-wrapper-vtext');
    if(!wrapper) return;
    var main = wrapper.querySelector('.splide:not(.splide--text-nav)');
    var nav = wrapper.querySelector('.splide--text-nav');
    if(main) main.style.height = '';
    if(nav){
      nav.style.height = '';
      var track = nav.querySelector('.splide__track');
      if(track) track.style.height = '';
    }
  }, true);
}

document.addEventListener('DOMContentLoaded', function() {
  sliderVtext();
});
